import React from "react";
import { McqQuestion } from "./McqQuestion";
import {
  PRESTATION_TYPES, INTERVENTION_CONTEXTS, CERTIFICATIONS, GEO_ZONES,
  PURCHASE_FREQ, BASKET_RANGES, CYCLE_RANGES, PRICE_POSITIONING,
  ACQUISITION_CHANNELS, STRENGTHS, BUSINESS_CHALLENGES, MATURITY_LEVELS,
} from "./constants";

/** Step 2 — Activité & offre (12 MCQ, mobile-first enlarged cards) */
export function StepOffer({ form, up }) {
  return (
    <div className="space-y-5">
      <div className="rounded-xl px-5 py-4 border border-emerald-500/30 bg-emerald-500/10">
        <p className="hp-label mb-1" style={{ color: "#86efac" }}>
          12 questions · environ 3 min
        </p>
        <p className="text-sm text-zinc-300 leading-relaxed">
          Cochez les cases qui correspondent. Prosperr s'appuiera sur ces choix pour générer vos cibles et vos scripts.
        </p>
      </div>

      {/* A. Décrire l'activité */}
      <McqQuestion
        title="1. Quels types de prestations proposez-vous ?"
        subtitle="Sélectionnez tout ce qui s'applique."
        mode="multi"
        options={PRESTATION_TYPES}
        value={form.prestation_types}
        onChange={(v) => up("prestation_types", v)}
        testidPrefix="q-prestation"
      />
      <McqQuestion
        title="2. Dans quels contextes intervenez-vous ?"
        mode="multi"
        options={INTERVENTION_CONTEXTS}
        value={form.intervention_contexts}
        onChange={(v) => up("intervention_contexts", v)}
        testidPrefix="q-context"
      />
      <McqQuestion
        title="3. Avez-vous des certifications ou labels ?"
        subtitle="Optionnel — utile pour rassurer vos prospects."
        mode="multi"
        options={CERTIFICATIONS}
        value={form.certifications}
        onChange={(v) => up("certifications", v)}
        testidPrefix="q-cert"
      />
      <McqQuestion
        title="4. Quelle est votre zone d'intervention ?"
        mode="single"
        options={GEO_ZONES}
        value={form.geo_intervention}
        onChange={(v) => up("geo_intervention", v)}
        testidPrefix="q-geo"
        columns={1}
      />

      {/* B. Offre & business */}
      <McqQuestion
        title="5. À quelle fréquence vos clients achètent-ils ?"
        mode="single"
        options={PURCHASE_FREQ}
        value={form.purchase_frequency}
        onChange={(v) => up("purchase_frequency", v)}
        testidPrefix="q-freq"
      />
      <McqQuestion
        title="6. Panier moyen par commande ?"
        mode="single"
        options={BASKET_RANGES}
        value={form.basket_range}
        onChange={(v) => up("basket_range", v)}
        testidPrefix="q-basket"
        columns={1}
      />
      <McqQuestion
        title="7. Quelle est la durée typique d'un cycle de vente ?"
        mode="single"
        options={CYCLE_RANGES}
        value={form.cycle_range}
        onChange={(v) => up("cycle_range", v)}
        testidPrefix="q-cycle"
      />
      <McqQuestion
        title="8. Comment vous positionnez-vous en prix ?"
        mode="single"
        options={PRICE_POSITIONING}
        value={form.price_positioning}
        onChange={(v) => up("price_positioning", v)}
        testidPrefix="q-price"
      />

      {/* C. Différenciation & contexte */}
      <McqQuestion
        title="9. Quels canaux d'acquisition utilisez-vous actuellement ?"
        subtitle="Sélectionnez ceux qui vous amènent déjà des clients."
        mode="multi"
        options={ACQUISITION_CHANNELS}
        value={form.acquisition_channels}
        onChange={(v) => up("acquisition_channels", v)}
        testidPrefix="q-acq"
      />
      <McqQuestion
        title="10. Vos 3 principaux atouts face à la concurrence ?"
        subtitle="Maximum 3 — on priorisera les plus impactants."
        mode="multi"
        maxSelect={3}
        options={STRENGTHS}
        value={form.strengths}
        onChange={(v) => up("strengths", v)}
        testidPrefix="q-strength"
      />
      <McqQuestion
        title="11. Quel est votre principal défi commercial aujourd'hui ?"
        mode="single"
        options={BUSINESS_CHALLENGES}
        value={form.main_challenge}
        onChange={(v) => up("main_challenge", v)}
        testidPrefix="q-challenge"
      />
      <McqQuestion
        title="12. À quel stade se trouve votre activité ?"
        mode="single"
        options={MATURITY_LEVELS}
        value={form.maturity_level}
        onChange={(v) => up("maturity_level", v)}
        testidPrefix="q-maturity"
      />
    </div>
  );
}
